import { render, staticRenderFns } from "./RoundDetails.vue?vue&type=template&id=59a9d337"
import script from "./RoundDetails.vue?vue&type=script&lang=js"
export * from "./RoundDetails.vue?vue&type=script&lang=js"
import style0 from "./RoundDetails.vue?vue&type=style&index=0&id=59a9d337&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports